import React, { useEffect, useRef, useState } from "react";
 import { useStepNavigate } from "../hooks/useStepNavigate";
 import { dataService } from "../services/dataService";
 import { useOrder } from "../context/OrderContext";
 import TablerLayout from "../components/layout/TablerLayout";
 import StepperNavButton from "../components/stepper/StepperNavButton";
 import ShoeLoader from "../components/loaders/ShoeLoader";
 import Modal from "../components/modals/Modal";
 
 const Taj = () => {
 	const { order, updateOrder } = useOrder();
 
 	const [tajNumber, setTajNumber] = useState(Array(9).fill(""));
 	const inputRefs = useRef([]);
 	const navigate = useStepNavigate();
 	const [isModalVisible, setIsModalVisible] = useState(false);
 	const [loading, setLoading] = useState(false);
 	const [message, setMessage] = useState("");
 	const [focusIndex, setFocusIndex] = useState(null);
 	const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

 	console.log("Rendelés adatok:", order);
 
 	const handleBeforeInput = (e) => {
 		if (e.data && /\D/.test(e.data)) {
 			e.preventDefault();
 		}
 	};
 
 	const handleInputChange = (e, index) => {
 		const value = e.target.value.replace(/\D/g, "");
 		const newTajNumber = [...tajNumber];

 		if (!value) {
 			newTajNumber[index] = "";
 			setTajNumber(newTajNumber);
 			return;
 		}

 		let i = index;
 		for (const char of value) {
 			if (i > 8) break;
 			newTajNumber[i] = char;
 			i++;
 		}

 		setTajNumber(newTajNumber);
 		if (i <= 8) {
 			setFocusIndex(i);
 		}
 	};
 
 	const handlePaste = (e) => {
 		const pastedData = e.clipboardData.getData("Text").replace(/\D/g, "");
 		if (pastedData.length === 9) {
 			const newTajNumber = pastedData.split("");
 			setTajNumber(newTajNumber);
 			setTimeout(() => {
 				inputRefs.current[8]?.focus();
 				inputRefs.current[8]?.select();
 			}, 10);
 			e.preventDefault();
 		}
 	};
 
 	const handleKeyDown = (e, index) => {
 		if (e.key === "Backspace" && !tajNumber[index] && index > 0) {
 			inputRefs.current[index - 1]?.focus();
 		}
 		if (e.key === "Enter" && tajNumber.every((num) => num !== "")) {
 			handleSubmit();
 		}
 	};
 
 	const handleSubmit = async () => {
    if (!tajNumber.every((num) => num !== "")) return;

    const taj = tajNumber.join("");
    const postData = {
        taj,
        hmeliorder_szam: order.hmeliorder?.hmeliorder_szam,
        hmeliorder_specific_id: order.hmeliorder?.hmeliorder_specific_id,
    };

    setLoading(true);
    try {
        const response = await dataService.checkTaj(postData);
        const data = response.data;

        if (data.status === "error") {
            setMessage(data.message || "Hiba történt a TAJ szám ellenőrzése során.");
            setLoading(false);
            showModal();
            return;
        }

        if (!data.ojote) {
            setMessage("A TAJ számhoz nem található adat.");
            setLoading(false);
            showModal();
            return;
        }

        if (order.hmeliorder?.hmeliorder_order_type < 3) {
            if (data.ojote.ojote_jogviszony_status === "error") {
                setMessage("A TAJ számhoz nem található érvényes jogviszony.");
                setLoading(false);
                showModal();
                return;
            }

            if (data.ojote.ojote_jogviszony_status === "ok") {
                if (data.ojote.ojote_jogviszony === "S") {
                    setMessage("Jogviszony: Sárga");
                    setLoading(false);
                    return;
                }
                if (data.ojote.ojote_jogviszony === "B") {
                    setMessage("Jogviszony: Barna");
                    setLoading(false);
                    return;
                }
                if (data.ojote.ojote_jogviszony === "Z") {
                    
                    setMessage("Jogviszony: Zöld (érvényes)");
                    
                    setLoading(false);
                    if (data.data.length === 1) {
                        updateOrder({ ...order, partner: data.data[0], ojote: data.ojote });
                        setTimeout(() => {
                            navigate("/Adat");
                        }, 2000);
                    } else {
                        updateOrder({ ...order, ojote: data.ojote });
                        setTimeout(() => {
                            navigate("/PartnerValaszto");
                        }, 2000);
                    }
                    return;
                }
                if (data.ojote.ojote_jogviszony !== "Z") {
                    setLoading(false);
                    return;
                }
            }
        }

        if (data.data.length === 1) {
            updateOrder({
                ...order,
                partner: {
                    ...data.data[0],
                    partner_taj: data.data[0]?.partner_taj || taj,
                },
                ojote: data.ojote,
            });
            setLoading(false);
            setTimeout(() => {
                navigate("/Adat");
            }, 2000);
        } else {
            updateOrder({ ...order, ojote: data.ojote });
            setLoading(false);
            setTimeout(() => {
                navigate("/PartnerValaszto");
            }, 2000);
        }
    } catch (error) {
        setMessage("Hiba történt a TAJ szám ellenőrzése során.");
        setLoading(false);
        showModal();
    }
};

const handleRetry = () => {
    setMessage("");
    setTajNumber(Array(9).fill(""));
    setIsModalVisible(false);
    setTimeout(() => {
        inputRefs.current[0]?.focus();
        inputRefs.current[0]?.select();
    }, 80);
};

const handlePrivateOrder = () => {
    updateOrder({
        ...order,
        hmeliorder: {
            ...order.hmeliorder,
            hmeliorder_order_type: 3,
        },
    });
    navigate("/PartnerValaszto");
};

const handleBackClick = () => {
    navigate("/RendelesTipus");
};

const showModal = () => {
    setIsModalVisible(true);
};

const canSubmit = tajNumber.every((num) => num !== "");

useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
}, []);

useEffect(() => {
    const t = setTimeout(() => {
        inputRefs.current[0]?.focus({ preventScroll: true });
        inputRefs.current[0]?.select();
    }, 80);

    return () => clearTimeout(t);
}, [isMobile]);

useEffect(() => {
    if (focusIndex !== null) {
        inputRefs.current[focusIndex]?.focus();
        inputRefs.current[focusIndex]?.select();
        setFocusIndex(null);
    }
}, [focusIndex, tajNumber]);

const renderTajInput = (index) => (
    <input
        key={index}
        onPaste={handlePaste}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        autoComplete="off"
        value={tajNumber[index]}
        onChange={(e) => handleInputChange(e, index)}
        onKeyDown={(e) => handleKeyDown(e, index)}
        onBeforeInput={handleBeforeInput}
        maxLength="1"
        autoFocus={index === 0}
        ref={(el) => {
            inputRefs.current[index] = el;
        }}
        onFocus={(e) => e.target.select()}
        style={{
            width: 56,
            height: 66,
            textAlign: "center",
            fontSize: 24,
            border: "1px solid #ccc",
            borderRadius: 0,
            background: "#fff",
        }}
    />
);

return (
    <TablerLayout title="TAJ szám megadása">
        <div className="row justify-content-center">
            <div className="col-md-10 text-center mb-4">
                <div className="mb-3">
                    <label className="form-label" style={{ fontWeight: 600, fontSize: 20 }}>
                        Kérjük, adja meg a TAJ számot:
                    </label>

                    {isMobile ? (
                        <div className="d-flex flex-column align-items-center">
                            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                                {[0, 1, 2].map((index) => renderTajInput(index))}
                            </div>

                            <div style={{ fontSize: 24, lineHeight: "32px", height: 32 }}>-</div>

                            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                                {[3, 4, 5].map((index) => renderTajInput(index))}
                            </div>

                            <div style={{ fontSize: 24, lineHeight: "32px", height: 32 }}>-</div>

                            <div style={{ display: "flex", gap: 6, justifyContent: "center" }}>
                                {[6, 7, 8].map((index) => renderTajInput(index))}
                            </div>
                        </div>
                    ) : (
                        <div style={{ display: "flex", justifyContent: "center", gap: 6 }}>
                            {tajNumber.map((_, index) => (
                                <React.Fragment key={index}>
                                    {renderTajInput(index)}
                                    {(index + 1) % 3 === 0 && index < 8 && (
                                        <span
                                            style={{
                                                fontSize: 24,
                                                height: 66,
                                                lineHeight: "60px",
                                                display: "inline-block",
                                                verticalAlign: "middle",
                                                margin: "0 6px",
                                            }}
                                        >
                                            -
                                        </span>
                                    )}
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                </div>

                {process.env.NODE_ENV === "development" && (
                    <div style={{ display: "flex", gap: 8, justifyContent: "center", marginBottom: 16 }}>
                        <button
                            type="button"
                            className="btn btn-warning btn-sm"
                            onClick={() => setTajNumber("118411514".split(""))}
                        >
                            TAJ: 118411514 (DEV)
                        </button>

                        <button
                            type="button"
                            className="btn btn-warning btn-sm"
                            onClick={() => setTajNumber("111111111".split(""))}
                        >
                            TAJ: 111111111 (DEV)
                        </button>
                    </div>
                )}

                {message && (
                    <div
                        style={{
                            marginTop: 16,
                            width: "100%",
                            minHeight: "2.5em",
                            fontSize: "1.1rem",
                            padding: "10px",
                            border: message ? "1px solid #ccc" : "none",
                            background: message ? "#fffbe6" : "transparent",
                            color: "#333",
                            marginBottom: 16,
                        }}
                    >
                        OJOTE eredmény: {message}
                    </div>
                )}

                {loading && (
                    <div style={{ textAlign: "center", margin: "0" }}>
                        <ShoeLoader />
                    </div>
                )}
            </div>
        </div>

        <Modal
            isOpen={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            title="Figyelem!"
            type="danger"
            onConfirm={handlePrivateOrder}
            confirmText="Privát megrendelés"
            confirmClass="btn-elit-lila"
            onSecondary={handleRetry}
            secondaryText="TAJ szám újra megadása"
            secondaryClass="btn-primary"
            showSecondary={true}
            showCancel={false}
            width="md"
            icon={<i className="bi bi-exclamation-triangle-fill text-danger" style={{ fontSize: "2rem" }}></i>}
        >
            <h4>Érvénytelen TAJ szám!</h4>
            <div className="text-secondary mt-2">{message}</div>
        </Modal>

        <StepperNavButton side="left" label="Vissza" onClick={handleBackClick} disabled={loading} />
        <StepperNavButton side="right" label="Tovább" onClick={handleSubmit} disabled={!canSubmit || loading} />
    </TablerLayout>
	);
 };

export default Taj;
